import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon, DescriptionOutlined as DescriptionOutlinedIcon, LocalAtm as LocalAtmIcon } from '@mui/icons-material';
import LOOKUP from 'constants/lookup';
import { reportCrumb } from 'utils/breadcrumbInfo';
import { getUserRoleReportByName } from "actions/EntityActions";
// Basic Components
import Button from 'screens/components/basic/Button';
import Grid from 'screens/components/basic/Grid';
import PageHeader from 'screens/components/basic/PageHeader';
import CardSimple from 'screens/components/basic/CardSimple';
import ReportWraper from './ReportWraper';
import 'styles/sass/report/index.scss';


class ReportPage extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isSelected: false,
            reportName: '',
            noticeOpen: false
        };
    }

    componentDidMount() {
        this.props.getUserRoleReportByName(this.props.roleName[0]);
    }


    backToReports = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                isSelected: false,
                reportName: ''
            };
        });
    }


    checkReportAccess = (reportId) => {
        let hasAccess = false;
        if (this.props.hasReportAccessList) {
            let result = this.props.hasReportAccessList.find(_ => _.reportType == reportId);
            if (result) {
                hasAccess = result.hasAccess;
            }
        }
        if (this.props.roleName.includes("StoreOwner"))
            hasAccess = true;
        return hasAccess;
    }

    getAllCategories = () => {
        let report = LOOKUP.report;
        let reportArray = [];
        Object.keys(report).forEach(function (key) {
            if (report[key].isReport) {
                reportArray.push({
                    reportType: report[key].id,
                    category: report[key].category
                });
            }
        });
        return reportArray;
    };

    checkReportCategory = (category) => {
        let showCategory = false;
        let allCategories = this.getAllCategories();

        if (this.props.hasReportAccessList) {
            let categoryList = this.props.hasReportAccessList.map(_ => {
                if (_.hasAccess) {
                    const category = allCategories.find(item => item.reportType == _.reportType);
                    return category ? category.category : null;
                }
                return null;
            });
            if (categoryList.find(_ => _ == category)) {
                showCategory = true;
            }
        }

        if (this.props.roleName.includes("StoreOwner")) {
            showCategory = true;
        }

        return showCategory;
    }

    noticeOnClick = () => {
        this.setState({ noticeOpen: !this.state.noticeOpen })
    }

    render() {
        const header = (
            <div className="page_header">
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active">{LOOKUP.report.text}</li>
                </ol>
                <h4> {LOOKUP.report.text} {this.state.isSelected ? <Button type="HeaderBackPage" onTouchTap={this.backToReports} /> : ""} </h4>
            </div>
        );
        return (
            <Grid headerContent={reportCrumb} className="Report">
                <PageHeader title={LOOKUP.report.text} />
                {
                    this.state.isSelected ?
                        <ReportWraper reportName={this.state.reportName} />
                        :
                        <React.Fragment>
                            <Accordion className="reportBox">
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                    className="remove-card-pb mb-3 p-0"
                                >
                                    <div className="col-sm-12 d-flex justify-content-center">
                                        <button onTouchTap={this.noticeOnClick} style={{ backgroundColor: "#f2e6c4" }}>
                                            <h4>IMPORTANT NOTICE: Report Merges</h4>
                                            <h6>Multiple reports have been merged. <b>Click here</b> for the merging details.</h6>
                                            {this.state.noticeOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </button>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <h6>"Sales Summary" includes:</h6>
                                    <ul>
                                        <li>Monthly Sales Summary</li>
                                        <li>Annual Sales Summary</li>
                                        <li>Daily Sales By Type</li>
                                        <li>Profit Report</li>
                                        <li>Tax Summary</li>
                                        <li>Combined Sales Report</li>
                                        <li>Transaction Count Summary</li>
                                        <li>Shopping Trend</li>
                                    </ul>
                                    <h6>"Aggregate Sales & Inventory" includes:</h6>
                                    <ul>
                                        <li>Aggregate Sales Report</li>
                                        <li>Inventory & Sales</li>
                                        <li>Aggregate Branches</li>
                                    </ul>
                                    <h6>If you have set user role premissions for these old reports, you must set premission again for the new merged reports</h6>
                                </AccordionDetails>
                            </Accordion>

                            {/* HIGHTIDE ONLY */}
                            {(this.props.isHighTide || this.props.isInspired) && this.checkReportCategory(LOOKUP.report.common.reportCategory.MANAGEMENTEREPORTS) ?
                                <div className="row report-sub-title">
                                    <h4>{LOOKUP.report.common.reportCategory.MANAGEMENTEREPORTS}</h4>
                                </div>
                                : null
                            }
                            {
                                (this.props.isHighTide || this.props.isInspired) &&
                                <div className="row d-flex justify-content-center">
                                    <Link to={LOOKUP.report.HightideReports.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <DescriptionOutlinedIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.HightideReports.text}</h5>
                                    </Link>
                                </div>
                            }

                            {/* END HIGHTIDE ONLY */}

                            {this.checkReportCategory(LOOKUP.report.common.reportCategory.SALESREPORTS) ?
                                <div className="row report-sub-title">
                                    <h4>{LOOKUP.report.common.reportCategory.SALESREPORTS}</h4>
                                </div>
                                : null
                            }

                            <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.transactionDetails.id) ?
                                    <Link to={LOOKUP.report.transactionDetails.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <DescriptionOutlinedIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.transactionDetails.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.SalesSummaryDetails.id) ?
                                    <Link to={LOOKUP.report.SalesSummaryDetails.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <DescriptionOutlinedIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.SalesSummaryDetails.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.categorysales.id) ?

                                    <Link to={LOOKUP.report.categorysales.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-tags fa-1-5x report_icon report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.categorysales.text}</h5>
                                    </Link>
                                    : null
                                }

                            </div>

                            <div className="row d-flex justify-content-center">

                                {this.checkReportAccess(LOOKUP.report.productSales.id) ?

                                    <Link to={LOOKUP.report.productSales.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-tags fa-1-5x report_icon report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.productSales.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.discountReport.id) ?
                                    <Link to={LOOKUP.report.discountReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-line-chart fa-1-5x report_icon report_icon_sm report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.discountReport.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.hourlySales.id) ?

                                    <Link to={LOOKUP.report.hourlySales.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-line-chart fa-1-5x report_icon report_icon_sm report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.hourlySales.text}</h5>
                                    </Link>
                                    : null
                                }


                            </div>
                            <div className="row d-flex justify-content-center">

                                {this.checkReportAccess(LOOKUP.report.sellThrough.id) ?
                                    <Link to={LOOKUP.report.sellThrough.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-line-chart fa-1-5x report_icon report_icon_sm report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.sellThrough.text}</h5>
                                    </Link>
                                    : null
                                }

                                {/* {this.checkReportAccess(LOOKUP.report.gmroiReport.id) ?

                                    <Link to={LOOKUP.report.gmroiReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-line-chart fa-1-5x report_icon report_icon_sm report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.gmroiReport.text}</h5>
                                    </Link>
                                    : null
                                } */}

                                {this.checkReportAccess(LOOKUP.report.brandSales.id) ?
                                    <Link to={LOOKUP.report.brandSales.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.brandSales.text}</h5>
                                    </Link>
                                    : null
                                }

                            </div>

                            <div className="row d-flex justify-content-center">

                                {this.checkReportAccess(LOOKUP.report.onlineInstore.id) ?
                                    <Link to={LOOKUP.report.onlineInstore.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.onlineInstore.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.orderList.id) ?
                                    <Link to={LOOKUP.report.orderList.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.orderList.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.hourlySalesDateRange.id) ?
                                    <Link to={LOOKUP.report.hourlySalesDateRange.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.hourlySalesDateRange.text}</h5>
                                    </Link>
                                    : null
                                }

                            </div>
                            <div className="row d-flex justify-content-center">

                                {this.checkReportAccess(LOOKUP.report.hourlySalesSecondary.id) ?
                                    <Link to={LOOKUP.report.hourlySalesSecondary.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.hourlySalesSecondary.text}</h5>
                                    </Link>
                                    : null
                                }

                            </div>

                            {this.checkReportCategory(LOOKUP.report.common.reportCategory.CASHMANAGEMENT) ?
                                <div className="row report-sub-title">
                                    <h4>{LOOKUP.report.common.reportCategory.CASHMANAGEMENT}</h4>
                                </div>
                                : null
                            }

                            <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.dailyCashSummary.id) ?
                                    <Link to={LOOKUP.report.dailyCashSummary.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.dailyCashSummary.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.creditPayments.id) ?
                                    <Link to={LOOKUP.report.creditPayments.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.creditPayments.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.creditPayments.id) ?
                                    <Link to={LOOKUP.report.giftCardBalance.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-gift fa-1-5x report_icon report_icon_sm report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.giftCardBalance.text}</h5>
                                    </Link>
                                    : null
                                }
                            </div>

                            {this.checkReportCategory(LOOKUP.report.common.reportCategory.EMPLOYEE) ?
                                <div className="row report-sub-title">
                                    <h4>{LOOKUP.report.common.reportCategory.EMPLOYEE}</h4>
                                </div>
                                : null
                            }

                            <div className="row d-flex justify-content-center">

                                {this.checkReportAccess(LOOKUP.report.employeeHours.id) ?

                                    <Link to={LOOKUP.report.employeeHours.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.employeeHours.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.employeeTimesheet.id) ?
                                    <Link to={LOOKUP.report.employeeTimesheet.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-calendar fa-1-5x report_icon report_icon_sm report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.employeeTimesheet.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.budtenderAvgSales.id) ?
                                    <Link to={LOOKUP.report.budtenderAvgSales.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-users fa-1-5x report_icon report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.budtenderAvgSales.text}</h5>
                                    </Link>
                                    : null
                                }
                            </div>

                            <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.deliveryReport.id) ?
                                    <Link to={LOOKUP.report.deliveryReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-truck fa-1-5x report_icon report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.deliveryReport.text}</h5>
                                    </Link>
                                    : null
                                }
                            </div>

                            {this.checkReportCategory(LOOKUP.report.common.reportCategory.INVENTORY) ?
                                <div className="row report-sub-title">
                                    <h4>{LOOKUP.report.common.reportCategory.INVENTORY}</h4>
                                </div>
                                : null
                            }

                            <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.inventorySnapShot.id) ?
                                    <Link to={LOOKUP.report.inventorySnapShot.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-cubes fa-1-5x report_icon report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.inventorySnapShot.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.manualInventoryChange.id) ?
                                    <Link to={LOOKUP.report.manualInventoryChange.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-cubes fa-1-5x report_icon report_icon_sm report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.manualInventoryChange.text}</h5>
                                    </Link>
                                    : null
                                }

                                {/* {this.checkReportAccess(LOOKUP.report.inventoryLevel.id) ?
                                    <Link to={LOOKUP.report.inventoryLevel.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-cubes fa-1-5x report_icon report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.inventoryLevel.text}</h5>
                                    </Link>
                                    : null
                                } */}
                            </div>

                            <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.revenueReport.id) ?
                                    <Link to={LOOKUP.report.revenueReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.revenueReport.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.reorderReport.id) ?
                                    <Link to={LOOKUP.report.reorderReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.reorderReport.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.purchaseOrderReport.id) ?

                                    <Link to={LOOKUP.report.purchaseOrderReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.purchaseOrderReport.text}</h5>
                                    </Link>
                                    : null
                                }

                            </div>

                            <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.warehouseTransfer.id) ?
                                    <Link to={LOOKUP.report.warehouseTransfer.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.warehouseTransfer.text}</h5>
                                    </Link>
                                    : null
                                }
                                {this.checkReportAccess(LOOKUP.report.inventoryAge.id) ?
                                    <Link to={LOOKUP.report.inventoryAge.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.inventoryAge.text}</h5>
                                    </Link>
                                    : null
                                }

                                {this.checkReportAccess(LOOKUP.report.restockbyCaps.id) ?
                                    <Link to={LOOKUP.report.restockbyCaps.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.restockbyCaps.text}</h5>
                                    </Link>
                                    : null
                                }
                            </div>

                            <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.productbycategory.id) ?
                                    <Link to={LOOKUP.report.productbycategory.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.productbycategory.text}</h5>
                                    </Link>
                                    : null
                                }
                                {this.checkReportAccess(LOOKUP.report.purchaseOrderReceiver.id) ?
                                    <Link to={LOOKUP.report.purchaseOrderReceiver.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.purchaseOrderReceiver.text}</h5>
                                    </Link>
                                    : null
                                }
                                {this.checkReportAccess(LOOKUP.report.productPriceChangeReport.id) ?
                                    <Link to={LOOKUP.report.productPriceChangeReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.productPriceChangeReport.text}</h5>
                                    </Link>
                                    : null
                                }
                            </div>
                            <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.giftCardReport.id) ?
                                    <Link to={LOOKUP.report.giftCardReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-gift fa-1-5x report_icon report_icon_sm report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.giftCardReport.text}</h5>
                                    </Link>
                                    : null
                                }
                                {this.checkReportAccess(LOOKUP.report.MonthlyInventory.id) ?
                                    <Link to={LOOKUP.report.MonthlyInventory.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-cubes fa-1-5x report_icon report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.MonthlyInventory.text}</h5>
                                    </Link>
                                    : null
                                }
                                {this.checkReportAccess(LOOKUP.report.InventoryMovement.id) ?
                                    <Link to={LOOKUP.report.InventoryMovement.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-cubes fa-1-5x report_icon report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.InventoryMovement.text}</h5>
                                    </Link>
                                    : null
                                }

                            </div>
                            <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.InventoryLog.id) ?
                                    <Link to={LOOKUP.report.InventoryLog.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-cubes fa-1-5x report_icon report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.InventoryLog.text}</h5>
                                    </Link>
                                    : null
                                }
                                {this.checkReportAccess(LOOKUP.report.AuditReport.id) ?
                                    <Link to={LOOKUP.report.AuditReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-cubes fa-1-5x report_icon report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.AuditReport.text}</h5>
                                    </Link>
                                    : null
                                }
                                {this.checkReportAccess(LOOKUP.report.UncountedReport.id) ?
                                    <Link to={LOOKUP.report.UncountedReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-cubes fa-1-5x report_icon report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.UncountedReport.text}</h5>
                                    </Link>
                                    : null
                                }
                            </div>

                            {this.checkReportCategory(LOOKUP.report.common.reportCategory.CONSOLIDATEDREPORT) ?
                                <div className="row report-sub-title">
                                    <h4>{LOOKUP.report.common.reportCategory.CONSOLIDATEDREPORT}</h4>
                                </div>
                                : null
                            }

                            <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.endOfDay.id) ?

                                    <Link to={LOOKUP.report.endOfDay.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.endOfDay.text}</h5>
                                    </Link>
                                    : null
                                }
                                {this.checkReportAccess(LOOKUP.report.AggregateBranchSalesInventory.id) ?
                                    <Link to={LOOKUP.report.AggregateBranchSalesInventory.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.AggregateBranchSalesInventory.text}</h5>
                                    </Link>
                                    : null
                                }
                                {this.checkReportAccess(LOOKUP.report.budgetPlannerReport.id) ?

                                    <Link to={LOOKUP.report.budgetPlannerReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.budgetPlannerReport.text}</h5>
                                    </Link>
                                    : null
                                }
                            </div>
                            <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.aggregateInventoryLevel.id) ?

                                    <Link to={LOOKUP.report.aggregateInventoryLevel.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.aggregateInventoryLevel.text}</h5>
                                    </Link>
                                    : null
                                }
                                {this.checkReportAccess(LOOKUP.report.productRakingReport.id) ?

                                    <Link to={LOOKUP.report.productRakingReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.productRakingReport.text}</h5>
                                    </Link>
                                    : null
                                }
                                {this.checkReportAccess(LOOKUP.report.irccReport.id) ?

                                    <Link to={LOOKUP.report.irccReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.irccReport.text}</h5>
                                    </Link>
                                    : null
                                }
                            </div>
                            <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.generalReport.id) ?

                                    <Link to={LOOKUP.report.generalReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.generalReport.text}</h5>
                                    </Link>
                                    : null
                                }
                            </div>
                            {this.checkReportCategory(LOOKUP.report.common.reportCategory.CUSTOMERS) ?
                                <div className="row report-sub-title">
                                    <h4>{LOOKUP.report.common.reportCategory.CUSTOMERS}</h4>
                                </div>
                                : null
                            }
                            <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.customerSales.id) ?

                                    <Link to={LOOKUP.report.customerSales.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.customerSales.text}</h5>
                                    </Link>
                                    : null
                                }
                                {this.checkReportAccess(LOOKUP.report.membersDemographics.id) ?

                                    <Link to={LOOKUP.report.membersDemographics.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.membersDemographics.text}</h5>
                                    </Link>
                                    : null
                                }
                            </div>
                            {this.checkReportCategory(LOOKUP.report.common.reportCategory.COMPLIANCE) ?
                                <div className="row report-sub-title">
                                    <h4>{LOOKUP.report.common.reportCategory.COMPLIANCE}</h4>
                                </div>
                                : null
                            }
                            <div className="row d-flex justify-content-center">

                                {this.checkReportAccess(LOOKUP.report.destroyedProductReport.id) ?
                                    <Link to={LOOKUP.report.destroyedProductReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.destroyedProductReport.text}</h5>
                                    </Link>
                                    : null
                                }
                                {/* { this.checkReportAccess(LOOKUP.report.FiskalyCashPointClosingReport.id) ?
                                   <Link to={LOOKUP.report.FiskalyCashPointClosingReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <LocalAtmIcon className="report_icon report_bg" />
                                        <h5>{LOOKUP.report.FiskalyCashPointClosingReport.text}</h5>
                                    </Link>
                                    : null
                                } */}
                            </div>

                            {/* REMOVE LATER */}
                            {/* {this.checkReportAccess(LOOKUP.report.salesSummary.id) ?

                                <Link to={LOOKUP.report.salesSummary.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-3 report_component">
                                    <i className="fa fa-usd fa-1-5x report_icon report_bg" aria-hidden="true" />
                                    <h5>{LOOKUP.report.salesSummary.text}</h5>
                                </Link>
                                : null
                            } */}

                            {/* {this.checkReportAccess(LOOKUP.report.annualSales.id) ?
                                <Link to={LOOKUP.report.annualSales.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-3 report_component">
                                    <i className="fa fa-pie-chart fa-1-5x report_icon report_icon_sm report_bg" aria-hidden="true" />
                                    <h5>{LOOKUP.report.annualSales.text}</h5>
                                </Link>
                                : null
                            } */}
                            {/* {this.checkReportAccess(LOOKUP.report.transactionSummary.id) ?
                                <Link to={LOOKUP.report.transactionSummary.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                    <LocalAtmIcon className="report_icon report_bg"/>
                                    <h5>{LOOKUP.report.transactionSummary.text}</h5>
                                </Link>
                                : null
                            } */}

                            {/* {this.checkReportAccess(LOOKUP.report.profitReport.id) ?

                                <Link to={LOOKUP.report.profitReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                    <LocalAtmIcon className="report_icon report_bg"/>
                                    <h5>{LOOKUP.report.profitReport.text}</h5>
                                </Link>
                                : null
                            } */}

                            {/* {this.checkReportAccess(LOOKUP.report.salesBytype.id) ?

                                <Link to={LOOKUP.report.salesBytype.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                    <LocalAtmIcon className="report_icon report_bg"/>
                                    <h5>{LOOKUP.report.salesBytype.text}</h5>
                                </Link>
                                : null
                            } */}

                            {/* {this.checkReportAccess(LOOKUP.report.monthlyProductSales.id) ?

                                <Link to={LOOKUP.report.monthlyProductSales.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                    <i className="fa fa-line-chart fa-1-5x report_icon report_icon_sm report_bg" aria-hidden="true" />
                                    <h5>{LOOKUP.report.monthlyProductSales.text}</h5>
                                </Link>
                                : null
                            } */}
                            {/* {this.checkReportAccess(LOOKUP.report.shoppingTrend.id) ?

                                <Link to={LOOKUP.report.shoppingTrend.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                    <i className="fa fa-line-chart fa-1-5x report_icon report_icon_sm report_bg" aria-hidden="true" />
                                    <h5>{LOOKUP.report.shoppingTrend.text}</h5>
                                </Link>
                                : null
                            } */}

                            {/* {this.checkReportAccess(LOOKUP.report.combinedSalesReport.id) ?

                                <Link to={LOOKUP.report.combinedSalesReport.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                    <i className="fa fa-line-chart fa-1-5x report_icon report_icon_sm report_bg" aria-hidden="true" />
                                    <h5>{LOOKUP.report.combinedSalesReport.text}</h5>
                                </Link>
                                : null
                            } */}

                            {/* {this.checkReportCategory(LOOKUP.report.common.reportCategory.TAX) ?
                                <div className="row mr-5 mb-4">
                                    <h2 className='ml-5 purpleText'>{LOOKUP.report.common.reportCategory.TAX}</h4>
                                    <div className="col-lg-12 d-block ml-5 mr-5 reportBorder">
                                    </div>
                                </div>
                                : null
                            } */}

                            {/* <div className="row d-flex justify-content-center">
                                {this.checkReportAccess(LOOKUP.report.taxSummary.id) ?
                                    <Link to={LOOKUP.report.taxSummary.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                        <i className="fa fa-bar-chart fa-1-5x report_icon report_bg" aria-hidden="true" />
                                        <h5>{LOOKUP.report.taxSummary.text}</h5>
                                    </Link>
                                    : null
                                }
                            </div> */}
                            {/* {this.checkReportAccess(LOOKUP.report.aggregateBranches.id) ?

                                <Link to={LOOKUP.report.aggregateBranches.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                    <LocalAtmIcon className="report_icon report_bg"/>
                                    <h5>{LOOKUP.report.aggregateBranches.text}</h5>
                                </Link>
                                : null
                            } */}
                            {/* {this.checkReportAccess(LOOKUP.report.aggregateSales.id) ?

                                <Link to={LOOKUP.report.aggregateSales.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                    <LocalAtmIcon className="report_icon report_bg"/>
                                    <h5>{LOOKUP.report.aggregateSales.text}</h5>
                                </Link>
                                : null
                            } */}
                            {/* {this.checkReportAccess(LOOKUP.report.aggregateInventory.id) ?
                                <Link to={LOOKUP.report.aggregateInventory.link} className="col-xs-10 col-sm-3 col-md-3 col-lg-2 col-xl-2 report_component">
                                    <LocalAtmIcon className="report_icon report_bg"/>
                                    <h5>{LOOKUP.report.aggregateInventory.text}</h5>
                                </Link>
                                : null
                            } */}
                        </React.Fragment>
                }
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        roleName: state.common.authenticatedUser.roles,
        hasReportAccessList: state.entity.userRoleReport ? state.entity.userRoleReport.access : null,
        isHighTide: state.common.applicationSettings.isHighTide,
        isInspired: state.common.applicationSettings.isInspired
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getUserRoleReportByName: (roleName) => dispatch(getUserRoleReportByName(roleName))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportPage);